import { render, staticRenderFns } from "./GiftVendorModal.Style#Drawer.vue?vue&type=template&id=ef2df1f8&scoped=true&"
import script from "./GiftVendorModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./GiftVendorModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./GiftVendorModal.Style#Drawer.vue?vue&type=style&index=0&id=ef2df1f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2df1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef2df1f8')) {
      api.createRecord('ef2df1f8', component.options)
    } else {
      api.reload('ef2df1f8', component.options)
    }
    module.hot.accept("./GiftVendorModal.Style#Drawer.vue?vue&type=template&id=ef2df1f8&scoped=true&", function () {
      api.rerender('ef2df1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/GiftVendorModal.Style#Drawer.vue"
export default component.exports